<template>
    <div class="eyBc">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item class="hidden-xs-only"><i class="el-icon-location"></i></el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/' }" class="hidden-xs-only">首页</el-breadcrumb-item>
            <el-breadcrumb-item @click.native="cShow()">{{msg1}}</el-breadcrumb-item>
            <!-- <el-breadcrumb-item :to="{ path: pathRew }">{{msg1}}</el-breadcrumb-item> -->
            <el-breadcrumb-item>{{msg2}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
export default {
    props:['msg1','msg2','pathRew'],
    methods:{
        cShow(){
            this.$emit('changeShow')
        }
    }
    
}
</script>

<style lang="scss" scoped>
.eyBc{
    ::v-deep {
        .el-breadcrumb{
            font-size: vw(16);
            // padding-left: vw(360);
            line-height: 2.5;

            span{
                &:first-child{
                    .el-icon-arrow-right{
                        display: none;
                    }
                }

                &:nth-child(2){
                    padding-left: vw(8);
                }
            }

            .el-icon-location{
                font-size: 1.25rem;
                color: $font33;
            }
        }

        .el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover {
            color: $yyBlue;
        }
    }
}
</style>